import { supabase } from './supabase'

/**
 * Bir kez gösterilen ipuçları, hesaba bağlı (kullanıcı, 22 Eki 2026).
 *
 * Eskiden yalnız tarayıcıda (localStorage) tutuluyordu: garson başka
 * telefondan girince, tarayıcı verisi silinince ya da ana ekrandaki uygulama
 * Safari'den ayrı sayıldığı için ipucu yeniden çıkıyordu. Şimdi hesabın
 * kendi kaydında (auth user_metadata, `hint_<ad>`); tablo gerekmiyor.
 */
const field = (name: string) => `hint_${name}`

/** Hesap bu ipucunu gördü mü; okunamazsa `null` (bilinmiyor). */
export async function hintSeen(name: string): Promise<boolean | null> {
  if (!supabase) return null
  const { data, error } = await supabase.auth.getUser()
  if (error || !data.user) return null
  return data.user.user_metadata?.[field(name)] === true
}

/** "Gördü" diye işaretle. Hata uygulamayı durdurmuyor, ipucu bir kez daha çıkar. */
export async function markHintSeen(name: string): Promise<void> {
  if (!supabase) return
  const { error } = await supabase.auth.updateUser({ data: { [field(name)]: true } })
  if (error) console.error('[ipucu] hesaba yazılamadı', error)
}
